module.exports = __webpack_public_path__ + "static/media/22_portrait.6c923239.jpg";